module.exports = __webpack_public_path__ + "img/first-responders.b4d5ecf7.svg";